import Reflux from "reflux";

const INIT = {
  updateSortBy: {},
  updateSortOrder: {},
  handleFilters: {},
  resetFilters: {},
  setFinishedCampaignsHaveBeenLoaded: {}
};

const Actions = Reflux.createActions(INIT);

export default Actions;
